import React, { useEffect, useRef, useState } from "react";
import logo from "../../images/homepage/logoNew.svg";
import homeIco from "../../images/homepage/homeIco.svg";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import "./homeNew.css";
import { useDispatch, useSelector } from "react-redux";
import userAction from "../../redux/users/action";

import { Modal } from "react-bootstrap";
import broadCastIco from "../../images/broadCastIco.png";
import { useMediaQuery } from "react-responsive";
import { BroadcastModal } from "../modals/broadcastModal";
import { AnnualModal } from "../modals/annualModal";
import {
  courseDataMonthly,
  courseDataYearly,
  cryptoMiningData,
  youtubeMember,
} from "./courseData";
import api from "../../api";
import { GrSettingsOption, GrFolderCycle } from "react-icons/gr";
import { LuBriefcaseBusiness, LuChartBarStacked } from "react-icons/lu";
import { TfiDashboard } from "react-icons/tfi";
import { LuChartCandlestick } from "react-icons/lu";
import { FaBriefcase, FaTv } from "react-icons/fa";
import { MdManageHistory } from "react-icons/md";
import { BiSupport } from "react-icons/bi";
import { IoMdLogOut } from "react-icons/io";
import { BsInfoCircle } from "react-icons/bs";
import { User } from "lucide-react";
import { GodzillaTradesModal } from "../modals/godzilla/godzillaModal";

export const NavbarNew = ({ show, setShow, SubsData, setSubsData }) => {
  const userStore = useSelector((state) => state.userReducer);
  const notificationStore = useSelector((state) => state.notificationReducer);
  const { setUser } = userAction;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [courseData, setCourseData] = useState([]);
  const [activeBtn, setActiveBtn] = useState("monthly");
  const [basicType, setBasicType] = useState("guide1");
  const [YearlyType, setYearlyType] = useState("guide1");

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [showYearly, setShowYearly] = useState(false);
  const handleCloseYearly = () => setShowYearly(false);
  const handleShowYearly = () => setShowYearly(true);

  const [showGz, setShowGz] = useState(false);
  const handleClosegz = () => setShowGz(false);
  const handleShowGz = () => setShowGz(true);

  const [showBroadcast, setShowBroadcast] = useState(false);
  const handleCloseBroadcast = () => setShowBroadcast(false);
  const handleShowBroadcast = () => setShowBroadcast(true);
  const [loader, setLoader] = useState(false);

  const isTab = useMediaQuery({
    query: "(max-width: 1200px)",
  });
  const logout = async () => {
    let payload = {
      _id: userStore?.users?.user?._id,
    };
    setLoader(true);
    let logoutRes = await api.logout(payload);
    setLoader(false);
    dispatch(setUser({}));
    localStorage.removeItem("token");
    setSubsData({});
    let iframe = document.querySelector(".intercom-lightweight-app");
    if (iframe) {
      iframe.style.display = "none";
    }
    let text1 = document.getElementById("intercomHelpText");
    if (text1) {
      text1.style.display = "none";
    }
    navigate("/");
  };

  // const handleSetBasic = () => {
  //   setCourseData(courseData1)
  //   setActiveBtn("beginner")
  // }
  const handleSetMonthly = () => {
    setCourseData(courseDataMonthly);
    setActiveBtn("monthly");
  };
  // const handleSetBasicGuide = (type) => {
  //   setActiveBtn("monthly");
  //   if (type == "guide1") {
  //     setCourseData(courseDataMonthlyGuide1);
  //     setBasicType("guide1");
  //   }
  //   if (type == "guide2") {
  //     setCourseData(courseDataMonthlyGuide2);
  //     setBasicType("guide2");
  //   }
  //   if (type == "guide3") {
  //     setCourseData(courseDataMonthlyGuide3);
  //     setBasicType("guide3");
  //   }
  //   if (type == "guide4") {
  //     setCourseData(courseDataMonthlyGuide4);
  //     setBasicType("guide4");
  //   }
  //   if (type == "guide5") {
  //     setCourseData(courseDataMonthlyGuide5);
  //     setBasicType("guide5");
  //   }
  // };

  const handleSetYearly = () => {
    setCourseData(courseDataYearly);
    setActiveBtn("yearly");
  };
  // const handleSetYearlyGuide = (type) => {
  //   setActiveBtn("yearly");
  //   if (type == "guide1") {
  //     setCourseData(courseDataYearlyGuide1);
  //     setYearlyType("guide1");
  //   }
  //   if (type == "guide2") {
  //     setCourseData(courseDataYearlyGuide2);
  //     setYearlyType("guide2");
  //   }
  //   if (type == "guide3") {
  //     setCourseData(courseDataYearlyGuide3);
  //     setYearlyType("guide3");
  //   }
  //   if (type == "guide4") {
  //     setCourseData(courseDataYearlyGuide4);
  //     setYearlyType("guide4");
  //   }
  // };

  const handleMining = () => {
    setActiveBtn("mining");
    setCourseData(cryptoMiningData);
  };
  const handleMemeber = () => {
    setActiveBtn("member");
    setCourseData(youtubeMember);
  };
  // const handleSetAdvance = (type) => {
  //   setActiveBtn("advance");
  //   if (type == "scd") {
  //     setCourseData(courseDataAdvanceSCD);
  //   } else {
  //     setCourseData(courseDataAdvanceCBD);
  //   }
  // };

  useEffect(() => {
    setCourseData(courseDataMonthly);
  }, []);
  const [expanded, setExpanded] = useState(true);
  useEffect(() => {
    if (isTab) {
      if (!expanded) {
        let toggler = document.getElementById("navbar-toggler");
        toggler.click();
      }
    }
  }, [expanded]);

  const clickNoify = () => {
    if (notificationStore?.notification) {
      navigate("/support");
    }
  };

  const [showAccountMenu, setShowAccountMenu] = useState(false);
  const accountMenuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        accountMenuRef.current &&
        !accountMenuRef.current.contains(e.target)
      ) {
        setShowAccountMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);

  return (
    <nav className="navbar navbar-expand-xl navbar-light navbarNew">
      <div className="container">
        <Link className="navbar-brand" to="/">
          <img src={logo} alt="waqarzaka" />
        </Link>
        <button
          className="navbar-toggler"
          id="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
          onClick={() => setExpanded(true)}
        >
          <span className="navbar-toggler-icon" />
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item" style={isTab ? { order: 1 } : {}}>
              <Link className="homeNav" aria-current="page" to="/">
                <img src={homeIco} alt="home" />
              </Link>
            </li>
            <li className="nav-item" style={isTab ? { order: 4 } : {}}>
              <a className="nav-link" onClick={handleShowBroadcast}>
                <FaTv fontSize={20} />
                Channels
              </a>
            </li>
            {/* <li className="nav-item">
              <a className="nav-link" onClick={handleShowYearly}>
                Join Yearly
              </a>
            </li> */}
            <li className="nav-item" style={isTab ? { order: 5 } : {}}>
              <a
                className="nav-link"
                href="/#services"
                onClick={() => setExpanded(false)}
              >
                <GrSettingsOption fontSize={20} />
                Services
              </a>
            </li>
            <li className="nav-item" style={isTab ? { order: 6 } : {}}>
              <NavLink
                className="nav-link"
                to="/market-overview"
                onClick={() => setExpanded(false)}
              >
                <LuChartBarStacked fontSize={20} />
                Market
              </NavLink>
            </li>
            {/* <li className="nav-item">
              <NavLink
                className="nav-link"
                to="/calculators"
                onClick={() => setExpanded(false)}
              >
                Caculators
              </NavLink>
            </li> */}
            {userStore?.users?.user?._id && (
              <li className="nav-item" style={isTab ? { order: 7 } : {}}>
                <NavLink
                  className="nav-link"
                  onClick={() => setExpanded(false)}
                  to="/liquidity-radar"
                >
                  {" "}
                  <LuChartCandlestick fontSize={20} />
                  Liquidity Radar{" "}
                </NavLink>
              </li>
            )}
            {/* {!SubsData?.isSubscription && (
              <li className="nav-item">
                <a className="nav-link" onClick={handleShow}>
                  Courses
                </a>
              </li>
            )} */}
            {!userStore?.users?.user?._id && (
              <li className="nav-item" style={isTab ? { order: 8 } : {}}>
                <a
                  className="nav-link"
                  href="/#about"
                  onClick={() => setExpanded(false)}
                >
                  <BsInfoCircle fontSize={20} />
                  About
                </a>
              </li>
            )}

            {/* <li className="nav-item">
              <a
              className="nav-link"
              onClick={() => setExpanded(false)}
              href="/#testimonial"
              >
              {" "}
              Testimonial{" "}
              </a>
              </li> */}
            {userStore?.users?.user?._id && (
              <>
                <li className="nav-item" style={isTab ? { order: 3 } : {}}>
                  <NavLink
                    className="nav-link"
                    onClick={() => setExpanded(false)}
                    to="/checkout"
                  >
                    <GrFolderCycle fontSize={20} />
                    Subscription{" "}
                  </NavLink>
                </li>
                <li className="nav-item" style={isTab ? { order: 2 } : {}}>
                  <NavLink
                    className="nav-link"
                    onClick={() => setExpanded(false)}
                    to="/dashboard"
                  >
                    <TfiDashboard fontSize={22} />
                    Dashboard{" "}
                  </NavLink>
                </li>
                {/* <li className="nav-item">
                  <NavLink
                    className="nav-link"
                    onClick={() => setExpanded(false)}
                    to="/indicators"
                  >
                    <LuChartCandlestick fontSize={20} />
                    Indicators{" "}
                  </NavLink>
                </li> */}
              </>
            )}
          </ul>
          <div className="regMain">
            <Link
              className={
                userStore?.users?.user?.name
                  ? "SignUpBtn ms-2 "
                  : "SignUpBtn ms-2 mb-2-400"
              }
              onClick={handleShowGz}
            >
              Mobile App
            </Link>
            {userStore?.users?.user?.name ? (
              <>
                {notificationStore?.notification && (
                  <span className="notifyMain" onClick={clickNoify}>
                    <div className="notify"></div>
                    <i className="fa-solid fa-bell"></i>
                  </span>
                )}
                <div
                  className={
                    showAccountMenu ? "logoutDrop is-open" : "logoutDrop"
                  }
                  ref={accountMenuRef}
                >
                  <button
                    className={
                      userStore?.users?.user?.name
                        ? "SignUpBtn me-0 min-w-150"
                        : "SignUpBtn me-0 "
                    }
                    onClick={() => setShowAccountMenu((prev) => !prev)}
                  >
                    {userStore?.users?.user?.name.length > 8
                      ? userStore?.users?.user?.name?.slice(0, 8) + " ..."
                      : userStore?.users?.user?.name}
                    <i
                      className="fa-solid fa-chevron-down ms-2"
                      style={{ position: "relative", right: "-10px" }}
                    ></i>
                    <div
                      className="logout"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <Link
                        className="link"
                        to={"/subscription/history"}
                        onClick={() => setShowAccountMenu(false)}
                      >
                        <MdManageHistory fontSize={16} className="me-1" />
                        Pay History
                      </Link>
                      <Link
                        className="link"
                        to={"/support"}
                        onClick={() => setShowAccountMenu(false)}
                      >
                        {notificationStore?.notification && (
                          <div className="masgNotSeen">
                            <i className="fa-solid fa-message"></i>
                            <span></span>
                          </div>
                        )}
                        <BiSupport fontSize={16} className="me-1" />
                        Support
                      </Link>
                      <Link
                        className="link"
                        to={"/profile"}
                        onClick={() => setShowAccountMenu(false)}
                      >
                        <User style={{ height: 16 }} className="me-1" />
                        Profile
                      </Link>
                      {/* <Link className="link" to={"/contact-support"}>
                      Contact Support
                    </Link> */}
                      <button
                        className="link"
                        onClick={() => {
                          setShowAccountMenu(false);
                          logout();
                        }}
                        disabled={loader}
                      >
                        {loader ? (
                          <i
                            className="fa fa-spinner fa-pulse me-1 mb-1"
                            style={{ position: "relative", top: "-0px" }}
                          ></i>
                        ) : (
                          <IoMdLogOut fontSize={16} className="me-1" />
                        )}
                        Logout
                      </button>
                    </div>
                  </button>
                </div>
              </>
            ) : (
              <>
                <div className="d-flex ">
                  <Link className="loginBtn" to="/login">
                    Login
                  </Link>
                  <Link className="SignUpBtn" to="/signup">
                    New User Sign Up
                  </Link>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <Modal show={show} onHide={handleClose} centered className="courseModal">
        <Modal.Body>
          <div className="otpModalMain">
            <div className="closeIcon" onClick={handleClose}>
              <i className="fa-solid fa-xmark" />
            </div>
            <div className="couseModal">
              <div className="mainBtn">
                {/* <div className={activeBtn == "beginner" ?'groupBtn ':'groupBtn active'} onClick={handleSetBasic}>For Beginner's</div> */}
                <div
                  className={
                    activeBtn == "monthly" ? "groupBtn " : "groupBtn active"
                  }
                  onClick={handleSetMonthly}
                >
                  Facebook Monthly
                </div>
                <div
                  className={
                    activeBtn == "yearly" ? "groupBtn " : "groupBtn active"
                  }
                  onClick={handleSetYearly}
                >
                  For Yearly
                </div>
                {/* <div className={activeBtn == "advance" ?'groupBtn':'groupBtn active'}  onClick={handleSetAdvance}>For Advanced</div> */}
                <div
                  className={
                    activeBtn == "mining" ? "groupBtn " : "groupBtn active "
                  }
                  onClick={handleMining}
                >
                  Crypto Mining
                </div>
                <div
                  className={
                    activeBtn == "member" ? "groupBtn" : "groupBtn active"
                  }
                  onClick={handleMemeber}
                >
                  Youtube Members Only
                </div>
              </div>
              {/* {activeBtn == "monthly" && 
              <div className="advanceTypeMain mainBtn mt-2">
                <div className={basicType == "guide1"? 'groupBtn':'groupBtn active'}  onClick={()=>handleSetBasicGuide("guide1")}>Guide 1 Basics</div>
                <div className={basicType == "guide2"? 'groupBtn':'groupBtn active'}  onClick={()=>handleSetBasicGuide("guide2")}>Guide 2 Basics</div>
                <div className={basicType == "guide3"? 'groupBtn':'groupBtn active'}  onClick={()=>handleSetBasicGuide("guide3")}>Guide 3 Trading</div>
                <div className={basicType == "guide4"? 'groupBtn':'groupBtn active'}  onClick={()=>handleSetBasicGuide("guide4")}>Guide 4- Basics of Blockchain</div>
                <div className={basicType == "guide5"? 'groupBtn':'groupBtn active'}  onClick={()=>handleSetBasicGuide("guide5")}>Guide 5- Advance Blockchain</div>
              </div>
            } */}
              {/* {activeBtn == "yearly" && 
              <div className="advanceTypeMain mainBtn mt-2">
                <div className={YearlyType == "guide1"? 'groupBtn':'groupBtn active'}  onClick={()=>handleSetYearlyGuide("guide1")}>Guide 1 Basics</div>
                <div className={YearlyType == "guide2"? 'groupBtn':'groupBtn active'}  onClick={()=>handleSetYearlyGuide("guide2")}>Guide 2 Basics</div>
                <div className={YearlyType == "guide3"? 'groupBtn':'groupBtn active'}  onClick={()=>handleSetYearlyGuide("guide3")}>Guide 3 Trading</div>
                <div className={YearlyType == "guide4"? 'groupBtn':'groupBtn active'}  onClick={()=>handleSetYearlyGuide("guide4")}>Guide 4- Basics of Blockchain</div>
              </div>
            } */}
              {/* {activeBtn == "advance" && 
              <div className="advanceTypeMain mainBtn mt-2">
                <div className={courseData[0]?.title == "Lecture 1"? 'groupBtn active':'groupBtn '}  onClick={()=>handleSetAdvance("cbd")}>CUSTOM BLOCKCHAIN DEVELOPMENT</div>
                <div className={courseData[0]?.title == "Lecture 1"? 'groupBtn':'groupBtn active'}  onClick={()=>handleSetAdvance("scd")}>SMART CONTRACT DEVELOPMENT</div>
              </div>
            } */}
              <div className="linkM">
                {/* <a href={val?.link} target='_blank' className="link" key={key}>{val?.title}</a> */}
                {courseData.map((val, key) => (
                  <div className="accordion" id="accordionExample" key={key}>
                    <div className="">
                      <h2 className="accordion-header" id="headingOne">
                        <button
                          className="link"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#collapseOne${key}`}
                          aria-expanded="true"
                          aria-controls={`collapseOne${key}`}
                        >
                          {val?.title}
                        </button>
                      </h2>
                      {val?.link.split(",").length > 1 ? (
                        <div
                          id={`collapseOne${key}`}
                          className="accordion-collapse collapse"
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            {val?.link.split(",").map((item, key1) => (
                              <a
                                className="mb-1"
                                href={item}
                                key1={key1}
                                target="_blank"
                              >
                                {item}
                              </a>
                            ))}
                          </div>
                        </div>
                      ) : (
                        <div
                          id={`collapseOne${key}`}
                          className="accordion-collapse collapse"
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            <a href={val?.link} target="_blank">
                              {val?.link}
                            </a>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
              {/* <div className="videoMain">
              {courseData.map((val,key)=> (
              <div className="video" key={key}>
                {val?.video}
              </div>
              ))}
            </div> */}
              {/* {courseData[0]?.video &&
            <div className='text-center'>
              <a className='default-btn' href="https://www.youtube.com/playlist?list=PLeYUkJPHvOtuiaCtvKTA5cKPqUPwYphLC" target="_blank" rel="noopener noreferrer">Playlist</a>
            </div>
            } */}
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <AnnualModal show={showYearly} handleClose={handleCloseYearly} />
      <GodzillaTradesModal show={showGz} handleClose={handleClosegz} />

      <BroadcastModal
        showBroadcast={showBroadcast}
        handleCloseBroadcast={handleCloseBroadcast}
      />
    </nav>
  );
};
